.wrapper {
  display: block;
  max-width: 100%;
  height: 100%;
  background: var(--white-layout-301-level-0-elevation);
}

:host {
  display: block;
  max-width: 100%;
  height: 100%;
}

[slot='push-body-content'] {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.controls-header {
  display: flex;
  align-items: center;

  .manageButtonSelections {
    margin-left: calc(var(--spacer) * 4);
    align-self: center;

    .action-button {
      .action-button-text,
      .action-icon {
        vertical-align: middle;
      }

      .action-icon {
        font-size: 12px;
        display: inline-block;

        &:before {
          font-size: 32px;
        }
      }
    }

    gz-button[class='action-button']::part(button) {
      padding-right: var(--spacer);
    }
  }
}

::part(final-details) {
  overflow: hidden;
  text-overflow: ellipsis;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: initial;
}
